import type { TrafficLightColor } from 'components/shared/TrafficLight/TrafficLight';
import { TrafficLight } from 'components/shared/TrafficLight/TrafficLight';
import { connect } from 'react-redux';
import type { FormOwnProps } from 'shared/connect/connect';
import { hasBackTestPartialError, hasBackTestResult, isBackTestRunning } from 'state/backTest/backTest.selector';
import type { AppState } from 'state/state.model';

interface StateProps {
  color?: TrafficLightColor;
  className?: string;
  size?: string;
}

const mapStateToProps = (state: AppState, { formId }: FormOwnProps): StateProps => {
  return {
    color: getStatusColor(
      isBackTestRunning(state, formId),
      hasBackTestPartialError(state, formId),
      hasBackTestResult(state, formId),
    ),
    className: 'position-absolute start-75 translate-middle',
    size: 'xs',
  };
};
export const BackTestHeaderStatus = connect(mapStateToProps)(TrafficLight);

function getStatusColor(isRunning: boolean, isFailed: boolean, hasResult: boolean): TrafficLightColor | undefined {
  if (isRunning) {
    return 'warning';
  }
  if (isFailed) {
    return 'danger';
  }
  if (hasResult) {
    return 'success';
  }
}
